<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-book fa-fw"></i>Credenciamentos
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div>
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  href="#solicitacoes"
                  aria-controls="solicitacoes"
                  role="tab"
                  data-js="novas"
                  data-toggle="tab"
                >
                  <i class="fa fa-sign-in text-primary fa-2x"></i>
                  <span class="text-primary">Novas Solicitações</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#emAnalise"
                  aria-controls="emAnalise"
                  role="tab"
                  data-js="em-analise"
                  data-toggle="tab"
                >
                  <i class="fa fa-hourglass-start text-warning fa-2x"></i>
                  <span class="text-warning">Em Análise</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#liberadas"
                  aria-controls="liberadas"
                  role="tab"
                  data-js="liberadas"
                  data-toggle="tab"
                >
                  <i class="fa fa-check text-success fa-2x"></i>
                  <span class="text-success">Liberadas</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#bloqueadas"
                  aria-controls="bloqueadas"
                  data-js="bloqueadas"
                  role="tab"
                  data-toggle="tab"
                >
                  <i class="fa fa-times text-danger fa-2x"></i>
                  <span class="text-danger">Bloqueadas</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane" id="solicitacoes">
              <br />
              <table
                class="table table-bordered table-striped table-hover"
                v-if="novas.length"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="a in novas"
                    :key="a.id"
                    @mouseover="showByIndex = a.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ a.id }}</td>
                    <td>{{ a.person.name }}</td>
                    <td>{{ a.activity.name }}</td>
                    <td>{{ a.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === a.id">
                        <a
                          class="btn btn-sm btn-primary"
                          :href="'#/admin/persons?edit=' + a.person.id"
                        >
                          <i class="fa fa-pencil fa-fw"></i>
                        </a>
                        <div class="btn-group btn-group-sm" v-if="editVisible()">
                          <a
                            type="button"
                            class="btn dropdown-toggle"
                            :class="getState(a.state)"
                            data-toggle="dropdown"
                          >
                            <i class="fa" :class="getIcon(a.state)"></i>
                            {{ a.state }}
                            <span class="caret"></span>
                          </a>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                href="#"
                                @click="state = 'emAnalise'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-hourglass-start"></i> analisar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'liberado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-check"></i> liberar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'bloqueado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-times"></i> bloquear</a
                              >
                            </li>
                          </ul>
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="emAnalise">
              <br />
              <table class="table table-bordered table-striped table-hover"
                v-if="emAnalise.length"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="a in emAnalise"
                    :key="a.id"
                    @mouseover="showByIndex = a.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ a.id }}</td>
                    <td>{{ a.person.name }}</td>
                    <td>{{ a.activity.name }}</td>
                    <td>{{ a.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === a.id">
                        <a
                          class="btn btn-sm btn-primary"
                          :href="'#/admin/persons?edit=' + a.person.id"
                        >
                          <i class="fa fa-pencil fa-fw"></i>
                        </a>
                        <div class="btn-group btn-group-sm"  v-if="editVisible()">
                          <a
                            type="button"
                            class="btn dropdown-toggle"
                            :class="getState(a.state)"
                            data-toggle="dropdown"
                          >
                            <i class="fa" :class="getIcon(a.state)"></i>
                            {{ a.state }}
                            <span class="caret"></span>
                          </a>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                href="#"
                                @click="state = 'emAnalise'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-hourglass-start"></i> analisar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'liberado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-check"></i> liberar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'bloqueado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-times"></i> bloquear</a
                              >
                            </li>
                          </ul>
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="liberadas">
              <br />
              <table class="table table-bordered table-striped table-hover"
                v-if="liberados.length"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="a in liberados"
                    :key="a.id"
                    @mouseover="showByIndex = a.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ a.id }}</td>
                    <td>{{ a.person.name }}</td>
                    <td>{{ a.activity.name }}</td>
                    <td>{{ a.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === a.id">
                        <a
                          class="btn btn-sm btn-primary"
                          :href="'#/admin/persons?edit=' + a.person.id"
                        >
                          <i class="fa fa-pencil fa-fw"></i>
                        </a>
                        <div class="btn-group btn-group-sm"  v-if="editVisible()">
                          <a
                            type="button"
                            class="btn dropdown-toggle"
                            :class="getState(a.state)"
                            data-toggle="dropdown"
                          >
                            <i class="fa" :class="getIcon(a.state)"></i>
                            {{ a.state }}
                            <span class="caret"></span>
                          </a>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                href="#"
                                @click="state = 'emAnalise'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-hourglass-start"></i> analisar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'liberado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-check"></i> liberar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'bloqueado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-times"></i> bloquear</a
                              >
                            </li>
                          </ul>
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="bloqueadas">
              <br />
              <table class="table table-bordered table-striped table-hover"
                v-if="bloqueados.length"  
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="a in bloqueados"
                    :key="a.id"
                    @mouseover="showByIndex = a.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ a.id }}</td>
                    <td>{{ a.person.name }}</td>
                    <td>{{ a.activity.name }}</td>
                    <td>{{ a.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === a.id">
                        <a
                          class="btn btn-sm btn-primary"
                          :href="'#/admin/persons?edit=' + a.person.id"
                        >
                          <i class="fa fa-pencil fa-fw"></i>
                        </a>
                        <div class="btn-group btn-group-sm"  v-if="editVisible()">
                          <a
                            type="button"
                            class="btn dropdown-toggle"
                            :class="getState(a.state)"
                            data-toggle="dropdown"
                          >
                            <i class="fa" :class="getIcon(a.state)"></i>
                            {{ a.state }}
                            <span class="caret"></span>
                          </a>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                href="#"
                                @click="state = 'emAnalise'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-hourglass-start"></i> analisar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'liberado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-check"></i> liberar</a
                              >
                            </li>
                            <li>
                              <a
                                href="#"
                                @click="state = 'bloqueado'"
                                @click.prevent.stop="sendState(a.id, state)"
                              >
                                <i class="fa fa-times"></i> bloquear</a
                              >
                            </li>
                          </ul>
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "../../mixins/storage";
import Modal from "../../components/ui-elements/Modal.vue";
import Forms from "../Forms.vue";
import stateMix from "../../mixins/state";
export default {
  name: "Accreditations",
  inject: ["loading"],
  components: { Modal, Forms },
  data() {
    return {
      showByIndex: null,
      document: {},
      documents: [],
      showModal: null,
      show: null,
      selectDoc: null,
      type: null,
      accreditation: {},
      accreditations: [],
      state: "",
      search: "",
      user:{},
      config: {},
    };
  },
  mounted() {
    let abas = {};
    this.type = this.$route.query.type;

    abas.novas = document.querySelector('[data-js="novas"]');
    abas.emAnalise = document.querySelector('[data-js="em-analise"]');
    abas.liberadas = document.querySelector('[data-js="liberadas"]');
    abas.bloqueadas = document.querySelector('[data-js="bloqueadas"]');

    abas[this.type].click();

    this.loading.value = true;
    this.$http.get(`/config`).then((response) => {
      this.config = response.data;
    
      this.$http
        .get(`/auth/info/${storage.methods.getToken()}`)
        .then((response) => {
          this.user = response.data;
          this.$http.get("accreditation").then((response) => {
            this.accreditations = response.data;
          });
        });
    })
    setTimeout(() => (this.loading.value = false), 1000);
    console.log(this.editVisible())
    console.log("setor usuário: ", storage.methods.getUser().sectorId)
    console.log("setor config: ", this.config.sectorId)
  },
  methods: {
    sendState(id, state) {
      this.loading.value = true;

      this.accreditation.state = this.state;

      this.$http
        .post(`/accreditation/state/${id}/${state}`, this.accreditation)
        .then((response) => {
          this.$router.go().then((event)=>{
            event.preventDefault()
          });
        });
      setTimeout(() => (this.loading.value = false), 1000);
    },
    getIcon(stateName) {
      return stateMix.methods.getIcon(stateName);
    },
    getState(stateName) {
      return stateMix.methods.getState(stateName);
    },
    editVisible() {
      return (        
          storage.methods.getUser().sectorId == 21
      );
    },
  },
  computed: {    
    novas() {
      return this.accreditations.filter(
        (a) => a.state == "" || a.state == undefined
      );
    },
    emAnalise() {
      return this.accreditations.filter((a) => a.state === "emAnalise");
    },
    liberados() {
      return this.accreditations.filter((a) => a.state === "liberado");
    },
    bloqueados() {
      return this.accreditations.filter((a) => a.state === "bloqueado");
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/Accreditations.vue